<template>
  <div class="quote-overview">
    <template v-if="location == undefined || location == 'top'">
    <div class="box">
      <!-- // TODO - refactor and share between ChosenVehicle Custom Component -->
      <ChosenVehicle />
    </div>
    <div v-if="quote_premium!==null" class="box has-background-initio">
      <template v-if="!isAltFlow && !isRenewFlow">
        <h3>Monthly Payment</h3>
        <h3 class="title is-size-4"><sup class="is-size-8">$</sup> {{ quote_premium | toCurrencyNoSymbol }}</h3>
<!--        <p class="is-size-8 has-text-right">Incl GST &amp; Gov. Charges</p>-->
        <hr />
        <h3>Yearly Payment</h3>
        <h3 class="title is-size-4"><sup class="is-size-8">$</sup> {{ quote_premium_annual | toCurrencyNoSymbol }}</h3>
<!--        <p class="is-size-8 has-text-right">Incl GST &amp; Gov. Charges</p>-->
      </template>
      <template v-if="isRenewFlow">
        <template v-if="can_convert_to_monthly && quote_premium !== null && quote_premium_annual !== null">
          <h3>New Monthly Payment</h3>
          <h3 class="title is-size-4"><sup class="is-size-8">$</sup> {{ quote_premium | toCurrencyNoSymbol }}</h3>
          <p class="is-size-8 has-text-right">Monthly payment, NZD, inc GST.</p>
          <hr />
          <h3>New Yearly Payment</h3>
          <h3 class="title is-size-4"><sup class="is-size-8">$</sup> {{ quote_premium_annual | toCurrencyNoSymbol }}</h3>
          <p class="is-size-8 has-text-right">Payment for year, NZD, inc GST.</p>
        </template>
        <template v-else>
          <h3>New {{ paymentInterval() }} Payment</h3>
          <h3 class="title is-size-4"><sup class="is-size-8">$</sup> {{ quote_premium_annual | toCurrencyNoSymbol }}</h3>
            <template v-if="paymentInterval() === 'monthly'">
                <p class="is-size-8 has-text-right">Monthly payment, NZD, inc GST.</p>
            </template>
            <template v-else>
                <p class="is-size-8 has-text-right">Payment for year, NZD, inc GST.</p>
            </template>
        </template>
      </template>
      <template v-if="isAltFlow">
        <h3>Adjustment Amount</h3>
        <h3 class="title is-size-4"><sup class="is-size-8">$&nbsp;</sup>
          <template>{{ quote_premium_adjustment | toCurrencyNoSymbol }}</template>
        </h3>
        <p class="is-size-8 has-text-right">NZD, inc GST.</p>
      </template>
    </div>

    <div v-if="answers[this.getStep('quote')].vehicle_cover_type" class="box policy-benefits">
      <CoverFull v-if="answers[this.getStep('quote')].vehicle_cover_type == 'full'" />
      <CoverFireTheft v-if="answers[this.getStep('quote')].vehicle_cover_type == 'third-party-fire-theft'" />
      <CoverThirdParty v-if="answers[this.getStep('quote')].vehicle_cover_type == 'third-party-only'" />
    </div>
    </template>
    <template v-if="location == undefined || location == 'bottom'">
      <div class="box">
        <p><a href="#" @click.prevent="toggleModal()">How we pay vehicle claims</a></p>
        <modal
          v-if="this.modalOpen"
          :class="{ 'is-active': modalOpen }"
          v-on:childToParent="toggleModal"
          :title="payClaimsModalTitle"
        >
          <div class="content"  v-if="answers[this.getStep('quote')].vehicle_cover_type == 'full'">
            <p>Our goal is to put you back in the same situation you were before the damage to your car.</p>

            <strong>Repairable Damage</strong><br />
            <p>If your car can be fixed, we'll pay for repairs so that it looks and performs as it did before your accident. You have the choice of using your own repairer, or one from our Approved Repairer Network where you get a quality guarantee on the work done.</p>

            <strong>Major Damage</strong><br />
            <p>If your car is not repairable after a crash, we will deem it a total loss and pay you out the sum insured you selected for your car (minus your excess). We only provide agreed value cover, meaning you tell us the value; and that's what we pay for a total loss, no argument.</p>
          </div>

          <div class="content"  v-if="answers[this.getStep('quote')].vehicle_cover_type == 'third-party-fire-theft'">
            <p>Third party fire and theft cover is designed to protect your liability while you're driving, and cover you for some things that are out of your control.</p>
            <p>If you're at fault for a crash that damages another person's car (or property) we will pay to repair the other person's damage so that their car or property is in a similar condition to what it was before your accident.</p>

            <p><strong>Fire, Theft, and Natural Disaster</strong><br />
            If your car is damaged by a fire, theft or a natural disaster we will cover you to put you back in the same situation you were in before the damage to your car.</p>

            <p><strong>Repairable Damage</strong><br />
            If your car can be fixed, we'll pay for repairs so that it looks and performs as it did before the fire, theft or natural disaster damage. You have the choice of using your own repairer, or one from our Approved Repairer Network where you get a quality guarantee on the work done.</p>

            <p><strong>Major Damage</strong><br />
              If your car is not repairable after a fire/natural disaster,or is stolen and not recovered, we will deem it a total loss and pay you out the sum insured you selected for your car (minus your excess). We only provide agreed value cover, meaning you tell us the value; and that's what we pay for a total loss, no argument.</p>
          </div>

          <div class="content" v-if="answers[this.getStep('quote')].vehicle_cover_type == 'third-party-only'">
            <p>Third party only cover is designed to protect only your liability while you're driving.</p>
            <p>If you're at fault for a crash that damages another person's car (or property), we will pay to repair the other person's damage so that their car or property is in a similar condition to what it was before your accident.</p>
          </div>
        </modal>
        <hr />
        <p><a href="/policy-wording/initio_motor_vehicle_insurance_policy_NZ2105.pdf" target="_blank">Download vehicle policy wording</a></p>
      </div>

      <div class="underwriter-block is-flex">
        <div class="mr-2">
          <svg width="28" height="28" ><use href="#initio_tick_icon" /></svg>
        </div>
        <div class="">
          <!-- Updated from AA- to AA Jan 2024 -->
          <h3 class="title is-6 mb-2">Backed by AA rated insurer</h3>
          <p>This cover is underwritten by IAG New Zealand Limited. <a target="_blank" href="/financial-strength/">Learn more about financial strength rating</a></p>
        </div>
      </div>
      <hr class="is-thin mt-5" />
      <disclosure-block />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CoverFull from '@/components/partials/CoverFull.vue'
import CoverFireTheft from '@/components/partials/CoverFireTheft.vue'
import CoverThirdParty from '@/components/partials/CoverThirdParty.vue'
import ChosenVehicle from '@/components/initio/formulate/ChosenVehicle.vue'
import DisclosureBlock from "./DisclosureBlock";

export default {
  props: {
    quote_premium_annual: {
      type: Number,
    },
    quote_premium: {
      type: Number,
    },
    quote_premium_adjustment: {
      type: Number,
    },
    location: {
      type: String,
    },
    can_convert_to_monthly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DisclosureBlock,
    CoverFull,
    CoverFireTheft,
    CoverThirdParty,
    ChosenVehicle
  },
  methods: {
    emitModalMonthlyInsurance (event) {
      this.$emit('emitModalMonthlyInsurance', true)
    },
    toggleModal: function () {
        this.modalOpen = ! this.modalOpen;
    }
  },
  computed: {
    ...mapGetters({ answers: 'flattenedAnswers', getStep: 'getStep', isAltFlow: 'isAltFlow', isRenewFlow: 'isRenewFlow', paymentInterval: 'getPaymentInterval'}),
    payClaimsModalTitle: function(){
      let title = '';
      switch(this.answers[this.getStep('quote')].vehicle_cover_type){
        case 'full':
          title =  "How we pay Full Cover claims";
          break;
        case 'third-party-fire-theft':
          title = "How we pay Third Party Fire & Theft claims";
          break;
        case 'third-party-only':
          title = "How we pay Third Party Only claims";
          break;
        default:
          title =  "How we pay vehicle claims";
      }
      return title;
    }
  },
  data () {
    return {
        modalOpen: false
    }
  },
  name: 'initio-summary'
}

</script>

<style scoped lang="scss">

  .box {
    padding:1rem;
    a {
      font-size:0.875rem;
    }
  }

  .has-background-initio {
    color:#FFF;
    position:relative;
    z-index:20;
    border:none;

    h3 {
      text-transform:uppercase;
      font-weight:bold;
      font-size:0.625rem;
    }

    .title {
      color:#FFF;
      padding-bottom:0;
      margin-bottom:0;
    }

    .has-text-right {
      margin-top:-1rem;
    }

    hr {
      border-top-color:rgba(255,255,255,0.3);
    }
  }

  .is-size-8 {
    font-size:0.625rem;
  }

  .plate {
    display:inline-block;
    width:auto;
    text-transform:uppercase;
    background:#F3F3F3;
    border: 1px solid $light-grey;
  }

  .make {
    width: 64px;
    height: 48px;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    display: inline-block;
    vertical-align: middle;
  }

  .hide {
    display:none;
  }

  hr {
    border:0;
    border-top:1px solid $light-grey;
    background:none;
    margin:0.5rem 0;
  }

  ::v-deep {
    .chosen-vehicle-block {
      padding:0;
      background:none;
      border:none;

      .plate {
        background: #f3f3f3;
        border: 1px solid $light-grey;
      }
    }

    .box > .formulate-input-element {
      padding:0;
      margin:0;
    }
  }

</style>

<style lang="scss">
  .policy-benefits {
    margin-top:-2.5rem;
    padding-top:1.75rem !important;
    font-size:0.875rem;

    h3 {
      font-weight:900;
      line-height:1.75rem;
      font-size:0.9375rem;
    }

    ul {
      margin-bottom:0.5rem;

      li {
        line-height:1.75rem;
        display:block;
        vertical-align: middle;
        position:relative;
        padding-left:1.5rem;

        svg {
          position:absolute;
          left:0;
          top:0.4rem;
          margin-right:1rem;
          vertical-align: middle;
        }
      }
    }
  }
</style>
